export enum PageName {
  SETUP_YOUR_ACCOUNT = 'Setup your account',
  BUSINESS_DETAILS = 'Business Details',
  DIRECTOR_DETAILS = 'Director Details',
  CONFIRM_ADDRESS = 'Confirm Address',
  RES_ADDRESS = 'Residential Address',
  UPLOAD_DOCUMENTS = 'Upload documents',
  SETUP_COMPLETION = 'Setup Completion',
  BANK_DETAILS = 'Bank Details',
  PERSONAL_DETAILS = 'Personal Details',
  PERSONAL_SELFIE = 'Personal Selfie',
}
